import { MapMarkerPinIcon, MapMarkerTescomaStoreIcon } from 'public/svg/IconsSvg';
import { MapMarkerType } from 'types/map';
import twJoin from 'utils/twMerge';

type MarkerIconProps = {
    point: MapMarkerType;
    activeMarkerUuid: string | null;
    totalPoints: number;
    isCluster: boolean;
    totalPointsInCluster: number;
};

const storeIconBaseTwClass = 'pointer-events-auto cursor-pointer';
const activeIconTextTwClass = 'h-12 w-10 text-[#ffd637]';
const inactiveIconTextTwClass = 'h-[38px] w-8 text-[#202330]';

export const MarkerIcon: FC<MarkerIconProps> = ({
    activeMarkerUuid,
    isCluster,
    point,
    totalPointsInCluster,
    totalPoints,
}) => {
    if (isCluster) {
        return (
            <div
                className={twJoin(
                    storeIconBaseTwClass,
                    'relative z-two flex cursor-pointer items-center justify-center',
                )}
            >
                <div
                    className="z-4 icon absolute rounded-md bg-[#da0000]"
                    style={{
                        width: Math.min(45 + totalPointsInCluster / totalPoints, 60),
                        height: Math.min(35 + totalPointsInCluster / totalPoints, 45),
                    }}
                />
                <span className="z-[6] text-h6 font-medium text-white">{totalPointsInCluster}</span>
            </div>
        );
    }

    if (point.isPickupPoint && !point.postOffice) {
        return (
            <MapMarkerTescomaStoreIcon
                className={twJoin(
                    storeIconBaseTwClass,
                    point.identifier === activeMarkerUuid ? activeIconTextTwClass : inactiveIconTextTwClass,
                )}
            />
        );
    }

    return (
        <MapMarkerPinIcon
            className={twJoin(
                storeIconBaseTwClass,
                point.identifier === activeMarkerUuid ? activeIconTextTwClass : inactiveIconTextTwClass,
            )}
        />
    );
};
